import React, { useMemo } from 'react';

import dynamic from 'next/dynamic';

// TODO: Hack for dynamic import CSS missing issue - with assumption that users will be navigating to home of that entity
// TODO: Remove this once next js solves for this issue https://github.com/vercel/next.js/issues/33286
import ArtistHome from 'components/Artist/Display/Home';
import OrganizationHome from 'components/Organization/Display/Home';

import useAppContext from 'utils/hooks/useAppContext';
import useEntitySectionTabs from 'utils/hooks/useEntitySectionTabs';
import usePageContext from 'utils/hooks/usePageContext';

import { ENTITY_TYPES, FILTER_TYPES, ROUTE_RESERVED_KEYWORDS } from 'operabase-router/constants';

const Reviews = dynamic(() => import('components/Globals/Layout/StubPage/Tabs/Reviews'));
const Videos = dynamic(() => import('components/Globals/Layout/StubPage/Tabs/Videos'));
const DigitalVideoPage = dynamic(() => import('components/Globals/Layout/StubPage/Tabs/DigitalVideoPage'));
const Photos = dynamic(() => import('components/Globals/Layout/StubPage/Tabs/Photos'));
const OrganizationContacts = dynamic(() => import('components/Organization/Display/OrganizationContacts'));
const Biography = dynamic(() => import('components/Artist/Display/Biography'));
const Works = dynamic(() => import('components/Globals/Layout/StubPage/Tabs/Works'));
const AboutOrg = dynamic(() => import('components/Organization/Display/AboutOrg'));
const ArtistContacts = dynamic(() => import('components/Artist/Display/ArtistContacts'));
const Venues = dynamic(() => import('components/Organization/Display/Venues'));
const EntityRentalsList = dynamic(() => import('components/Productions/Display/EntityRentalsList'));
const SeasonsWrapper = dynamic(() => import('components/Productions/Display/Seasons'));
const Repertoire = dynamic(() => import('components/Artist/Display/Repertoire'));
const AgencyRosterView = dynamic(() => import('components/Organization/Display/AgencyRosterView'));

const NullComponent = () => null;

const EntityTabComponent = ({ isPreviewMode = false }) => {
  const { subPath, entity, isLoading } = usePageContext();
  const { obRouteContext } = useAppContext();
  const { page, linkProps } = obRouteContext;
  const { entityType, tab } = page || {};
  const tabs = useEntitySectionTabs({ entityType, entity });
  const tabValue = useMemo(() => {
    if (isPreviewMode) {
      const activeTab = tabs?.find(({ key }) => key === tab);

      if (activeTab) {
        return tab;
      }

      return null;
    }

    return tab;
  }, [tab, tabs, isPreviewMode]);

  const TabComponent = useMemo(() => {
    switch (tabValue) {
      case ROUTE_RESERVED_KEYWORDS.videos: {
        if (linkProps?.filters?.[FILTER_TYPES.WATCH_ONLINE]) {
          return DigitalVideoPage;
        }

        return Videos;
      }

      case ROUTE_RESERVED_KEYWORDS.images: {
        return Photos;
      }

      case ROUTE_RESERVED_KEYWORDS.reviews: {
        return Reviews;
      }

      case ROUTE_RESERVED_KEYWORDS.venues: {
        return Venues;
      }

      case ROUTE_RESERVED_KEYWORDS.performances: {
        return SeasonsWrapper;
      }

      case ROUTE_RESERVED_KEYWORDS.works: {
        return Works;
      }

      case ROUTE_RESERVED_KEYWORDS.about: {
        return AboutOrg;
      }

      case ROUTE_RESERVED_KEYWORDS.bio: {
        return Biography;
      }

      case ROUTE_RESERVED_KEYWORDS.repertoire: {
        return Repertoire;
      }

      case ROUTE_RESERVED_KEYWORDS.managers:

      case ROUTE_RESERVED_KEYWORDS.contact:
        switch (entityType) {
          case ENTITY_TYPES.PROFILE:
            return ArtistContacts;

          default: {
            return OrganizationContacts;
          }
        }

      case ROUTE_RESERVED_KEYWORDS.rentals:
        return EntityRentalsList;

      case ROUTE_RESERVED_KEYWORDS['agency-roster']:
        return AgencyRosterView;

      default:
        if (!tabValue) {
          switch (entityType) {
            case ENTITY_TYPES.ORGANIZATION: {
              return OrganizationHome;
            }
            case ENTITY_TYPES.PROFILE:
              return ArtistHome;
            default:
              return NullComponent;
          }
        }

        return NullComponent;
    }
  }, [tabValue, entityType, linkProps?.filters]);

  return (
    <TabComponent
      entityType={entityType}
      entity={entity}
      isLoading={isLoading}
      mainPath={tabValue}
      subPath={subPath}
      isPreviewMode={isPreviewMode}
    />
  );
};

export default EntityTabComponent;
